/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Progress_Extra_Calendar_RestInputs */

const en_us2_progress_extra_calendar_rest = /** @type {(inputs: Progress_Extra_Calendar_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: no workout`)
};

const pt_br2_progress_extra_calendar_rest = /** @type {(inputs: Progress_Extra_Calendar_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: sem treino`)
};

const es_419_progress_extra_calendar_rest = /** @type {(inputs: Progress_Extra_Calendar_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: sin entrenamiento`)
};

const pt_pt2_progress_extra_calendar_rest = /** @type {(inputs: Progress_Extra_Calendar_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: sem treino`)
};

const fr_fr2_progress_extra_calendar_rest = /** @type {(inputs: Progress_Extra_Calendar_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} : pas de séance`)
};

const de_de2_progress_extra_calendar_rest = /** @type {(inputs: Progress_Extra_Calendar_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: kein Training`)
};

const it_it2_progress_extra_calendar_rest = /** @type {(inputs: Progress_Extra_Calendar_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day}: nessun allenamento`)
};

/**
* | output |
* | --- |
* | "{day}: no workout" |
*
* @param {Progress_Extra_Calendar_RestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_calendar_rest = /** @type {((inputs: Progress_Extra_Calendar_RestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Calendar_RestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_calendar_rest(inputs)
	if (locale === "es-419") return es_419_progress_extra_calendar_rest(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_calendar_rest(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_calendar_rest(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_calendar_rest(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_calendar_rest(inputs)
	return en_us2_progress_extra_calendar_rest(inputs)
});
export { progress_extra_calendar_rest as "progress-extra.calendar_rest" }